import { translate } from '../../common/helpers/translate.helper';

export const getDeleteDraftConfirmPopupContent = (reference?: string) => ({
    headline: translate('alert.deleteDraft.headline', {
        reference: reference ?? '',
    }).trim(),
    text: translate('alert.deleteDraft.text'),
});
